import { SISTEMA } from '../../copy/index.js';
import { ICONO, WifiOff } from './iconos.js';

type BannerOfflineProps = {
  /** Cuántas respuestas esperan a que vuelva la conexión. */
  pendientes: number;
};

/**
 * Banner de "trabajando offline" (S-08).
 *
 * **Sin pantalla bloqueada de "no hay internet".** El paciente sigue viendo su
 * app y puede responder el check-in, que es justo lo que funciona sin conexión;
 * lo que necesita conexión se atenúa y se explica. Amarillo discreto, no rojo
 * crítico: no hay nada roto y el dato no se pierde.
 *
 * El punto que latía era un círculo de CSS que no decía qué pasaba. Ahora es el
 * ícono de la librería (ADR-016), que además de ser el mismo en todos los
 * teléfonos dice de qué se trata sin leer.
 *
 * Es `role="status"` y no `role="alert"`: se anuncia sin interrumpir lo que el
 * lector de pantalla esté leyendo.
 */
export function BannerOffline({ pendientes }: BannerOfflineProps) {
  return (
    <div
      className="sticky top-0 z-[var(--z-sticky)] flex items-center gap-3 rounded-lg bg-sem-yellow-bg px-4 py-3"
      role="status"
    >
      <WifiOff className={`${ICONO.normal} shrink-0 text-sem-yellow-fg`} />
      <p className="text-md font-semi text-sem-yellow-fg">
        {SISTEMA.offline.titulo}
        <span className="block font-regular">
          {pendientes === 0
            ? SISTEMA.offline.sinPendientes
            : SISTEMA.offline.pendientes(pendientes)}
        </span>
      </p>
    </div>
  );
}
